/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_ElbowInputs */

const en_us2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elbow`)
};

const pt_br2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotovelo`)
};

const es_419_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codo`)
};

const pt_pt2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotovelo`)
};

const fr_fr2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coude`)
};

const de_de2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellbogen`)
};

const it_it2_profile_editors_pain_area_elbow = /** @type {(inputs: Profile_Editors_Pain_Area_ElbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gomito`)
};

/**
* | output |
* | --- |
* | "Elbow" |
*
* @param {Profile_Editors_Pain_Area_ElbowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_elbow = /** @type {((inputs?: Profile_Editors_Pain_Area_ElbowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_ElbowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_elbow(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_elbow(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_elbow(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_elbow(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_elbow(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_elbow(inputs)
	return en_us2_profile_editors_pain_area_elbow(inputs)
});
export { profile_editors_pain_area_elbow as "profile-editors.pain_area_elbow" }